export function genDownloadUrl(record, suffix) {
  const baseName = record?.name.replace(/\s+/g, "").substring(0,30) || ""
  if (!baseName) {
  return record.audioUrl
  }

  const tag = suffix ? `-${suffix}` : ''
  const ext = record.audioUrl.substring(record.audioUrl.lastIndexOf(".")).toLowerCase()
  return `${record.audioUrl}?filename=${encodeURIComponent(baseName + tag + ext)}`
}